import { Handle, Position } from '@xyflow/react'

export function BlendNode({ data, selected }) {
  const alpha      = data.alpha ?? 0.5
  const hasVar     = !!data.alphaVariable
  const isAdditive = data.blendMode === 'additive'

  return (
    <div style={{
      background: selected ? '#1f2a2a' : '#161e1e',
      border: `2px solid ${selected ? '#40a0e0' : '#306070'}`,
      borderRadius: 6,
      padding: '10px 14px',
      minWidth: 170,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
    }}>
      {/* Title + mode toggle */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
        <span style={{ fontSize: 16 }}>⚖️</span>
        <span style={{ color: '#80c8e8', fontWeight: 'bold', fontSize: 11 }}>BLEND</span>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 0, borderRadius: 3, overflow: 'hidden', border: '1px solid #204050' }}>
          {['normal', 'additive'].map(mode => (
            <button
              key={mode}
              onMouseDown={e => e.stopPropagation()}
              onClick={() => data.onChange?.('blendMode', mode)}
              style={{
                background: (mode === 'additive') === isAdditive ? '#204050' : 'transparent',
                border: 'none',
                color: (mode === 'additive') === isAdditive ? '#80c8e8' : '#405060',
                padding: '2px 6px',
                fontSize: 9,
                fontFamily: 'var(--m-font)',
                cursor: 'pointer',
                letterSpacing: 0.3,
              }}
            >
              {mode === 'normal' ? 'N' : 'A'}
            </button>
          ))}
        </div>
      </div>

      {/* Input A */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6, position: 'relative' }}>
        <Handle
          type="target"
          position={Position.Left}
          id="a"
          style={{ background: '#e07040', width: 10, height: 10, top: '50%', transform: 'translateY(-50%)' }}
        />
        <span style={{ marginLeft: 14, color: '#aaa', fontSize: 11 }}>A</span>
      </div>

      {/* Input B */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10, position: 'relative' }}>
        <Handle
          type="target"
          position={Position.Left}
          id="b"
          style={{ background: '#e07040', width: 10, height: 10, top: '50%', transform: 'translateY(-50%)' }}
        />
        <span style={{ marginLeft: 14, color: '#aaa', fontSize: 11 }}>B</span>
      </div>

      {/* Alpha slider + wirable input */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3, position: 'relative' }}>
          <Handle
            type="target"
            position={Position.Left}
            id="alpha-in"
            style={{ background: '#4ecf7e', width: 8, height: 8, top: '50%', transform: 'translateY(-50%)' }}
          />
          <span style={{ marginLeft: 12, color: '#4ecf7e', fontSize: 10 }}>Alpha{hasVar ? ' (var)' : ''}</span>
          <span style={{ color: '#aaa', fontSize: 10 }}>{alpha.toFixed(2)}</span>
        </div>
        <input
          type="range"
          min={0} max={1} step={0.01}
          value={alpha}
          onChange={e => data.onChange?.('alpha', parseFloat(e.target.value))}
          onMouseDown={e => e.stopPropagation()}
          style={{ width: '100%', accentColor: '#4ecf7e', cursor: 'pointer' }}
        />
      </div>

      {/* Optional variable override */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ color: '#306050', fontSize: 9, marginBottom: 2 }}>Variable (optional)</div>
        <input
          type="text"
          value={data.alphaVariable ?? ''}
          onChange={e => data.onChange?.('alphaVariable', e.target.value || undefined)}
          onMouseDown={e => e.stopPropagation()}
          placeholder="none"
          style={{
            width: '100%', boxSizing: 'border-box',
            background: '#0a1a1a', border: '1px solid #1a3030',
            color: hasVar ? '#4ecf7e' : '#555', padding: '3px 6px',
            borderRadius: 3, fontSize: 10,
            fontFamily: 'var(--m-mono)', outline: 'none',
          }}
        />
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="anim"
        style={{ background: '#e07040', width: 10, height: 10 }}
      />
    </div>
  )
}
